"use strict" ;

/**
 * This {@link molecule.components.ButtonPhase} enumeration list all phases of the buttons.
 * @summary This {@link molecule.components.ButtonPhase} enumeration list all phases of the buttons.
 * @name ButtonPhase
 * @namespace molecule.components.ButtonPhase
 * @memberof molecule.components
 */
const ButtonPhase = Object.defineProperties( {} ,
{
    /**
     * The "disable" phase of the buttons.
     * @name DISABLE
     * @memberof molecule.components.ButtonPhase
     * @static
     * @type {string}
     * @default 'disable'
     */
    DISABLE : { enumerable : true , value : 'disable' } ,

    /**
     * The "down" phase of the buttons.
     * @name DOWN
     * @memberof molecule.components.ButtonPhase
     * @static
     * @type {string}
     * @default 'down'
     */
    DOWN : { enumerable : true , value : 'down' } ,

    /**
     * The "over" phase of the buttons.
     * @name OVER
     * @memberof molecule.components.ButtonPhase
     * @static
     * @type {string}
     * @default 'over'
     */
    OVER : { enumerable : true , value : 'over' } ,

    /**
     * The "up" phase of the buttons.
     * @name UP
     * @memberof molecule.components.ButtonPhase
     * @static
     * @type {string}
     * @default 'up'
     */
    UP : { enumerable : true , value : 'up' }
}) ;

export default ButtonPhase ;